import { Component, OnInit, AfterContentInit } from '@angular/core';
import { DynamicLoaderService } from './services/dynamic-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentInit {
  title = 'fe-sa';

  constructor(
    private readonly dynamicLoaderService: DynamicLoaderService,
  ) {

  }

  ngOnInit(): void {

  }

  ngAfterContentInit(): void {
    // this.dynamicLoaderService.loadCSS('/assets/css/dashforge.filemgr.css');
    // this.dynamicLoaderService.loadJS('/assets/js/dashforge.js');
    // this.dynamicLoaderService.loadJS('/assets/js/dashforge.filemgr.js');
    // this.dynamicLoaderService.loadJS('/assets/lib/peity/jquery.peity.min.js');
  }
}
